module.exports = __webpack_public_path__ + "static/media/p1.9c20e509.jpg";